import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import userReducer from './userReducer'
import messageReducer from './messageReducer'
import chatReducer from './chatReducer'
import websocketReducer from './websocketReducer'

// Configure persistence for different parts of the state
const userPersistConfig = {
  key: 'user',
  storage,
  whitelist: ['user', 'token', 'isAuthenticated']
}

const chatPersistConfig = {
  key: 'chat',
  storage,
  whitelist: ['sessions', 'sessionOrder'],
  // Transform to cleanup empty "New Chat" sessions on rehydration
  transforms: [
    {
      in: (state) => state, // No transform when saving
      out: (state) => {
        // Filter out empty "New Chat" sessions when loading from localStorage
        if (!state || !state.sessions) return state

        const cleanedSessions = {}
        const cleanedSessionOrder = []
        let removedCount = 0

        Object.entries(state.sessions).forEach(([id, session]) => {
          // Keep session if:
          // 1. It has a title other than "New Chat"
          // 2. Or it has messages (messageCount > 0)
          // 3. Or it has an answerId (completed research)
          const isEmptyNewChat =
            session.title === 'New Chat' &&
            (!session.messageCount || session.messageCount === 0) &&
            !session.answerId

          if (!isEmptyNewChat) {
            cleanedSessions[id] = session
            cleanedSessionOrder.push(id)
          } else {
            removedCount++
            console.log('🧹 Removing empty "New Chat" session:', id)
          }
        })

        if (removedCount > 0) {
          console.log(`✅ Cleaned up ${removedCount} empty "New Chat" session(s)`)
        }

        return {
          ...state,
          sessions: cleanedSessions,
          sessionOrder: cleanedSessionOrder
        }
      }
    }
  ]
}

const messagePersistConfig = {
  key: 'messages',
  storage,
  whitelist: ['messages', 'messagesBySession']
}

const rootReducer = combineReducers({
  user: persistReducer(userPersistConfig, userReducer),
  messages: persistReducer(messagePersistConfig, messageReducer),
  chat: persistReducer(chatPersistConfig, chatReducer),
  websocket: websocketReducer // Don't persist websocket state
})

export default rootReducer